'use client';
import { FC, useEffect, useRef, ChangeEventHandler } from 'react';
import { cvaBody, cvaClose, cvaCloseIcon, cvaHeader, cvaInner, cvaOverlay, cvaRoot } from './SortMobilePopupStyles';
import { motion } from 'framer-motion';
import IconClose from '/public/icons/close2.svg';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock-upgrade';
import Checkbox from '@/shared/ui/Checkbox/Checkbox';

interface Value {
  id?: string | number;
  value: string | number;
  label: string;
}

interface Props {
  onClose: () => void;
  data: Value[];
  activeValue: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const SortMobilePopup: FC<Props> = ({ data, activeValue, onChange, onClose }) => {
  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (bodyRef.current) {
      disableBodyScroll(bodyRef.current, {
        reserveScrollBarGap: true,
      });
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
      className={cvaRoot()}
      data-lenis-prevent
    >
      <div className={cvaOverlay()} onClick={onClose}></div>
      <div className={cvaInner()}>
        <div className={cvaHeader()}>
          показать сначала
          <button type="button" className={cvaClose()} onClick={() => onClose()}>
            <IconClose className={cvaCloseIcon()} />
          </button>
        </div>
        <div className={cvaBody()} ref={bodyRef}>
          {data.map((item) => (
            <Checkbox
              key={item.id}
              type="radio"
              name="mobile-sort"
              value={item.value}
              title={item.label}
              onChange={onChange}
              checked={activeValue === item.value}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SortMobilePopup;
